export enum ReportingFormName {
  PostingCreate = 'posting-create',
  PostingEdit = 'posting-edit',
  UserCsvUpload = 'user-csv-upload',
  CandidateInterviewInvite = 'candidate-interview-invite',
  EnableEasyApply = 'enable-easy-apply',
  DisableEasyApply = 'disable-easy-apply',
  SelfSignUp = 'self-sign-up',
  PostAJob = 'post-job',
  SaveAndSubscribe = 'save-and-subscribe',
  EnableAutoPilot = 'enable-autopilot',
  DisableAutoPilot = 'disable-autopilot',
}
